import React from 'react';

import styles from './SimpleSteps.module.scss';

const {
  'simple-steps': simpleStepsClass,
  'info-points': infoPointsClass,
  'dotted-line': dottedLineClass,
  'info-point': infoPointClass,
  'point-number': pointNumberClass
} = styles;

const infoPoints = [
  {
    title: '',
    subtitle: ''
  },
  {
    title: '',
    subtitle: ''
  },
  {
    title: '',
    subtitle: ''
  }
];

const SimpleSteps = () => {
  return (
    <div className={simpleStepsClass}>
      <div className={infoPointsClass}>
        <div className={dottedLineClass} />
        {infoPoints.map((point, idx) => (
          <div key={idx} className={infoPointClass}>
            <div className={pointNumberClass}>{idx + 1}</div>
          </div>
        ))}
      </div>
      <h2>3 simple steps - 100% online</h2>
      <p>
        We’ll help you build a custom funeral plan in a matter of minutes and instantly show you how
        much it will cost.
      </p>
    </div>
  );
};

export default SimpleSteps;
